import { ITaskV2AssignedUser } from '@fi-app/task-v2/fi-task-v2';
import { ILightWeightObject } from '@fi-shared/models';

export function getSortedRoles(assignee: ITaskV2AssignedUser, taskRoles: ILightWeightObject[]): ILightWeightObject[] {
    if (!taskRoles.length) {
        return assignee.Roles;
    }
    // Sort roles:
    // 1. Task roles first
    // 2. Other roles second
    // 3. Within each group, sort alphabetically

    return [...assignee.Roles].sort((a, b) => {
        const aInTask = taskRoles.some((tr) => tr.Id === a.Id);
        const bInTask = taskRoles.some((tr) => tr.Id === b.Id);

        if (aInTask && !bInTask) {
            return -1;
        }
        if (!aInTask && bInTask) {
            return 1;
        }
        return a.Name.localeCompare(b.Name);
    });
}

// Sorting requirements: https://chainformation.atlassian.net/browse/FI-6605
export function getSortedUnits(assignee: ITaskV2AssignedUser, taskUnits: ILightWeightObject[]): ILightWeightObject[] {
    if (!taskUnits.length) {
        // If there are no task units, then sort by preferred unit
        return [...assignee.BusinessUnits].sort((a, b) => {
            const aIsPreferred = a.Id === assignee.PreferredBusinessUnitId;
            const bIsPreferred = b.Id === assignee.PreferredBusinessUnitId;

            if (aIsPreferred && !bIsPreferred) {
                return -1;
            }
            if (!aIsPreferred && bIsPreferred) {
                return 1;
            }

            return a.Name.localeCompare(b.Name);
        });
    }
    // Sort units:
    // 1. Preferred unit first if it is in task units
    // 2. If preferred unit is not in task units, diplay task units first
    // 3. If preferred unit is not in task units, then preferred unit is next
    // 4. Remaining units last
    // 5. Within each group, sort alphabetically

    return [...assignee.BusinessUnits].sort((a, b) => {
        const aInTask = taskUnits.some((tu) => tu.Id === a.Id);
        const bInTask = taskUnits.some((tu) => tu.Id === b.Id);
        const aIsPreferred = a.Id === assignee.PreferredBusinessUnitId;
        const bIsPreferred = b.Id === assignee.PreferredBusinessUnitId;

        // 1. Preferred unit first ONLY if it is in task units
        if (aInTask && bInTask) {
            if (aIsPreferred && !bIsPreferred) {
                return -1;
            }
            if (!aIsPreferred && bIsPreferred) {
                return 1;
            }
        }

        // 2. All task units come before non-task units
        if (aInTask && !bInTask) {
            return -1;
        }
        if (!aInTask && bInTask) {
            return 1;
        }

        // 3. Among non-task units, preferred unit comes first
        if (!aInTask && !bInTask) {
            if (aIsPreferred && !bIsPreferred) {
                return -1;
            }
            if (!aIsPreferred && bIsPreferred) {
                return 1;
            }
        }

        // 4. Within each group, sort alphabetically
        return a.Name.localeCompare(b.Name);
    });
}
